import { DomainUser } from '@oncolens/oncolens-ui/lib/dto/user/User';
import useAuthStore from '@oncolens/oncolens-ui/lib/stores/AuthStore';
import React from 'react';
import Avatar from 'react-avatar';

import { useConferenceManagement } from '@/hooks/featureFlags/active-flags/useConferenceManagement';
import { logout } from '@/services/LogoutService';

export const Header = () => {
  const domainUser = useAuthStore((x) => x.domainUser);
  const conferenceMangementFlag = useConferenceManagement();

  return (
    <>
      {conferenceMangementFlag ? (
        <HeaderV2 domainUser={domainUser} />
      ) : (
        <header
          className="h-16 border-b border-gray-300 bg-gray-800 px-3
          flex items-center text-white  shadow-lg">
          <h1 className="text-2xl font-bold">OncoLens Chancellor</h1>
          <div className="ml-auto mr-3">
            <Avatar name={domainUser?.email} round size={'36'} />
          </div>
          <button
            className="text-xs font-bold tracking-wide uppercase  px-3 mr-2
            transition-colors rounded-md hover:bg-slate-700"
            onClick={() => logout()}>
            Logout
          </button>
        </header>
      )}
    </>
  );
};

const HeaderV2 = ({ domainUser }: { domainUser: DomainUser | null }) => (
  <header className="font-lato min-h-20 h-20 bg-sky-500 px-6 flex items-center text-white  shadow-lg">
    <h1 className="text-xl font-bold">OncoLens Chancellor</h1>
    <div className="ml-auto mr-3">
      <Avatar
        name={domainUser?.email}
        round
        size="37"
        color="#C3E5FB"
        fgColor="#4BA2E3"
        textSizeRatio={2.65}
        className="text-sm font-bold uppercase"
      />
    </div>
    <button
      className="pl-2 text-xs font-bold tracking-wide transition-colors"
      onClick={() => logout()}>
      Logout
    </button>
  </header>
);
